import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

class OfficeService {
  async fetchOffices() {
    return Client.items()
      .type(KENTICO_TYPES.OFFICE)
      .toPromise();
  }
}

export default new OfficeService();



// WEBPACK FOOTER //
// ./src/services/office.service.js